/**
 * Transaction API Service
 * Service layer for vendor and customer transaction history API calls.
 * The record/param/response shapes are SHARED (types/api/transaction.ts) —
 * only the route differs (AP side keyed by vendorId, AR side by customerId).
 */

import apiClient from './axios.config';
import { CUSTOMER_ROUTES, VENDOR_ROUTES } from '@/constants/api.constants';
import type {
  TransactionListResponse,
  TransactionListParams,
} from '@/types/api/transaction';

/**
 * Transaction API service object
 */
export const transactionApi = {
  /**
   * GET /api/vendors/:vendorId/transactions
   * Fetch transaction history for a vendor
   */
  list: async (
    vendorId: number,
    params?: TransactionListParams
  ): Promise<TransactionListResponse> => {
    const response = await apiClient.get<TransactionListResponse>(
      VENDOR_ROUTES.TRANSACTIONS(vendorId),
      { params }
    );
    return response.data;
  },

  /**
   * GET /api/customers/:customerId/transactions
   * Fetch transaction history for a customer (#88)
   */
  listForCustomer: async (
    customerId: number,
    params?: TransactionListParams
  ): Promise<TransactionListResponse> => {
    const response = await apiClient.get<TransactionListResponse>(
      CUSTOMER_ROUTES.TRANSACTIONS(customerId),
      { params }
    );
    return response.data;
  },
};

export default transactionApi;
